// If you're looking for how recaptcha is used during submission, look in the form-embed module global.js